<template>
  <div class="content6-wrapper">
    <div class="content6">
      <div class="content6-header">
        <div class="content6-title1">数字乡村专题展示</div>
      </div>
      <div class="content6-content">
        <div class="content6-list">
          <div class="content6-list-left">
            <div class="content6-list-left-title1">数字乡村</div>
            <div class="content6-list-left-title2">
              "生产+治理+运营+服务"全链路解决方案
            </div>
            <div class="content6-list-left-list1">
              <div
                v-for="(item, index) in navItems"
                :key="index"
                class="content6-list-left-list1-item"
                :class="{ active: activeNav === index }"
                @click="handleNavClick(item, index)"
              >
                {{ typeof item === 'string' ? item : item.title }}
              </div>
            </div>
            <div class="content6-list-left-title3" @click="viewAllDigitalVillage">专题详情</div>
          </div>
          <div class="content6-list-right">
            <div class="content6-list-right-title">
              <span>数字乡村平台</span>
              将物联网、传感器、大数据等前沿技术与传统农业深度融合，实现农业数据集成化、标准化提供农业"生产+治理+运营+服务"全链路解决方案，为农业发展提供有力支撑，为乡村振兴开辟数字化新路径。
            </div>
            <div class="content6-list-right-d"></div>
            <div class="content6-list-right-list">
              <div
                v-for="(item, index) in features"
                :key="index"
                class="content6-list-right-list-item"
                @click="handleFeatureClick(item)"
              >
                <div class="img" :class="`img${index + 1}`"></div>
                <div class="span">{{ item.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Content6',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeNav: 0,
      navItems: [
        '基础数据管理',
        '网格综合管理',
        '发展规划管理',
        '生产过程保障'
      ],
      features: [
        {
          title: '综合治理',
          img: require('@/assets/6_2_1.png')
        },
        {
          title: '产业升级',
          img: require('@/assets/6_2_2.png')
        },
        {
          title: '党建文化',
          img: require('@/assets/6_2_3.png')
        },
        {
          title: '服务惠民',
          img: require('@/assets/6_2_4.png')
        }
      ]
    }
  },
  methods: {
    viewAllDigitalVillage() {
      this.$router.push('/special')
    },
    handleNavClick(item, index) {
      this.activeNav = index
    },
    handleFeatureClick() {
      // 可以添加跳转逻辑
    }
  }
}
</script>

<style scoped>
.content6-wrapper {
  background: #f4f7fc;
  overflow: hidden;
  position: relative;
  color: #242934;
}

.content6 {
  background: #f4f7fc;
  margin-top: 60px;
  margin-bottom: 76px;
  padding: 0;
}

.content6-header {
  .content6-title1 {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 36px;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    font-weight: bold;
    color: #242934;
  }
  .content6-title2 {
    cursor: pointer;
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 16px;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
    color: #1742bc;
  }
}

.content6-content {
  margin-top: 30px;
  position: relative;
  width: 100vw;
  height: 569px;
  background: url(@/assets/6_1.png) no-repeat;
  .content6-list {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1260px;
    height: 365px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    .content6-list-left {
      width: 290px;
      height: 365px;
      .content6-list-left-title1 {
        font-size: 36px;
        font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
        font-weight: 500;
        color: #ffffff;
        line-height: 28px;
      }
      .content6-list-left-title2 {
        margin-top: 17px;
        font-size: 14px;
        font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
        font-weight: 500;
        color: #ffffff;
      }
      .content6-list-left-list1 {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        .content6-list-left-list1-item {
          width: 291px;
          height: 46px;
          border-left: 1px solid rgba(255, 255, 255, 0.3);
          font-size: 14px;
          font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
          font-weight: 500;
          color: #ffffff;
          border-radius: 0px 4px 4px 0px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 24px;
          cursor: pointer;
          transition: all 0.3s ease;
        }
        .content6-list-left-list1-item:hover {
          background-color: rgba(255, 255, 255, 0.1);
        }
        .active {
          width: 291px;
          border-left: 1px solid rgba(255, 255, 255, 0.3);
          background-color: rgba(255, 255, 255, 0.25);
        }
      }
      .content6-list-left-title3 {
        margin-top: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 141px;
        height: 43px;
        border: 1px solid #ffffff;
        border-radius: 3px;
        font-size: 18px;
        font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      .content6-list-left-title3:hover {
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
    .content6-list-right {
      width: 922px;
      height: 365px;
      background: rgba(255, 255, 255, 0.97);
      border-radius: 12px;
      margin-left: 48px;
      .content6-list-right-title {
        margin-top: 60px;
        margin-left: 60px;
        width: 713px;
        height: 52px;
        font-size: 14px;
        font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
        color: #242934;
        line-height: 30px;
        span {
          font-size: 22px;
          font-weight: bold;
          margin-right: 10px;
        }
      }
      .content6-list-right-d {
        margin-top: 43px;
        margin-left: 60px;
        width: 816px;
        height: 1px;
        background: #374055;
        opacity: 0.09;
      }
      .content6-list-right-list {
        margin-top: 48px;
        margin-left: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .content6-list-right-list-item {
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          margin-right: 68px;
          cursor: pointer;
          transition: transform 0.3s ease;
          .img {
            width: 96px;
            height: 96px;
          }
          .img1 {
            background: url(@/assets/6_2_1.png) no-repeat center center / 100% 100%;
          }
          .img2 {
            background: url(@/assets/6_2_2.png) no-repeat center center / 100% 100%;
          }
          .img3 {
            background: url(@/assets/6_2_3.png) no-repeat center center / 100% 100%;
          }
          .img4 {
            background: url(@/assets/6_2_4.png) no-repeat center center / 100% 100%;
          }
          .span {
            font-size: 14px;
            font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
            font-weight: 500;
            color: #242934;
            margin-top: -16px;
          }
        }
        .content6-list-right-list-item:hover {
          transform: translateY(-5px);
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .content6-wrapper {
    .content6 {
      .home-page {
        padding: 64px 24px 32px;
      }
    }
  }
}
</style>